// // tracing.js
import { WebVitalsInstrumentation } from "@honeycombio/opentelemetry-web";
// import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import {
  WebTracerProvider /* , BatchSpanProcessor */,
} from "@opentelemetry/sdk-trace-web";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { Resource } from "@opentelemetry/resources";
import { SemanticResourceAttributes } from "@opentelemetry/semantic-conventions";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { getWebAutoInstrumentations } from "@opentelemetry/auto-instrumentations-web";
// import { honeycombApiKey } from "./app/utils/constants";

// The exporter is responsible for sending traces from the browser to your collector
// const exporter = new OTLPTraceExporter({
//   url: "https://api.honeycomb.io/v1/traces",
//   headers: {
//     "x-honeycomb-team": honeycombApiKey, // replace with your Honeycomb API key
//   },
// });

// The TracerProvider is the core library for creating traces
const provider = new WebTracerProvider({
  resource: new Resource({
    [SemanticResourceAttributes.SERVICE_NAME]: "platform-fe",
    "user_agent.original": window.navigator.userAgent, // add the user agent on every span
  }),
});

// The processor sorts through data as it comes in, before it is sent to the exporter
// provider.addSpanProcessor(new BatchSpanProcessor(exporter));
// A context manager allows OTel to keep the context of function calls across async functions
// ensuring you don't have disconnected traces
provider.register({
  contextManager: new ZoneContextManager(),
});

// initialize auto-instrumentation
registerInstrumentations({
  instrumentations: [
    getWebAutoInstrumentations(),
    new WebVitalsInstrumentation(),
  ],
});
